@import "../../global/normalize.css";

/**
 * @prop --input-width: Width of the input field
 * @prop --menu-width: Width of the dropdown menu
 * @prop --ic-z-index-menu: z-index of select menu
 */

:host {
  display: block;
  position: relative;

  --ic-input-label-helpertext-padding: var(--ic-space-xs);
  --menu-max-height: 100px;
  --border-color: var(--ic-select-field-border);
  --border-color-hover: var(--ic-select-field-border-hover);
  --border-color-pressed: var(--ic-select-field-border-pressed);
  --border-color-disabled: var(--ic-select-field-border-disabled);
  --border-color-error: var(--ic-select-field-border-error);
  --border-color-error-hover: var(--ic-select-field-border-error-hover);
  --border-color-error-pressed: var(--ic-select-field-border-error-pressed);
  --border-color-success: var(--ic-select-field-border-success);
  --border-color-success-hover: var(--ic-select-field-border-success-hover);
  --border-color-success-pressed: var(--ic-select-field-border-success-pressed);
  --border-color-warning: var(--ic-select-field-border-warning);
  --border-color-warning-hover: var(--ic-select-field-border-warning-hover);
  --border-color-warning-pressed: var(--ic-select-field-border-warning-pressed);
  --ic-input-label-text-color: var(--ic-select-field-label);
  --ic-input-label-helper-text-color: var(
    --ic-select-input-field-label-subtitle
  );
  --ic-input-validation-status-text-color: var(--ic-select-state-text);
  --ic-input-validation-error: var(--ic-select-state-icon-error);
  --ic-input-validation-warning-icon-color: var(--ic-select-state-icon-warning);
  --ic-input-validation-success-icon-color: var(--ic-select-state-icon-success);
  --menu-item-text-color: var(--ic-select-list-option-text);
  --menu-bg-color: var(--ic-select-list-option-background);
  --menu-border-color: var(--ic-select-dropdown-list-border);
}

:host(.ic-select-disabled) {
  --ic-input-label-text-color: var(--ic-select-field-label-disabled);
  --ic-input-label-helper-text-color: var(
    --ic-select-input-field-label-subtitle-disabled
  );
}

:host(.ic-select-full-width) {
  width: 100%;
}

ic-input-component-container.menu-open {
  --border-color: var(--ic-select-field-border-pressed);
}

ic-input-validation .status-icon,
ic-input-validation .statustext {
  visibility: visible;
}

ic-input-validation.menu-open .status-icon,
ic-input-validation.menu-open .statustext {
  visibility: hidden;
  transition: visibility 0s;
}

ic-input-label {
  margin-bottom: var(--ic-space-xs);
}

select {
  border: 0;
  border-radius: var(--ic-border-radius);
  background-color: var(--ic-select-field-background);
  color: var(--ic-select-content-text);
  line-height: 1.5rem;
  letter-spacing: 0.005rem;
  width: 100%;
  height: 100%;
  padding-left: 0.375rem;
  appearance: none;
  background-repeat: no-repeat;
  background-position: right 0.375rem center;
  background-image: var(--ic-select-mobile-dropdown-icon);
  caret-color: var(--ic-select-input-field-text-cursor);
}

select option,
.select-option-selected {
  color: var(--ic-select-list-option-text);
}

select:disabled {
  color: var(--ic-select-content-text-disabled);
  background-image: var(--ic-select-mobile-dropdown-icon-disabled);
}

select:focus {
  border: 0;
  outline: 0;
}

select:not([disabled]) {
  cursor: pointer;
}

.select-container {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
}

.select-input {
  width: 100%;
  height: 100%;
  padding: 0 0.375rem;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  background: none;
  border: none;
  background-color: var(--ic-select-field-background);
  color: var(--ic-select-content-text);
}

.select-input:focus {
  outline: none;
}

.select-input[disabled] {
  pointer-events: none;
}

:host(.ic-select-searchable) .select-input {
  cursor: auto;
}

.select-input.with-clear-button {
  padding-right: 0;
}

.value-text {
  max-width: calc(100% - (var(--ic-space-lg) + var(--ic-space-xxs)));
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0 !important;
}

.value-text.with-clear-button {
  padding-right: calc(var(--ic-space-xl) + var(--ic-space-xs));
}

.searchable-select-container {
  align-items: center;
  display: flex;
  width: 100%;
  position: relative;
}

.expand-icon {
  height: var(--ic-space-lg);
  padding-left: var(--ic-space-xxs);
  color: var(--ic-select-expand-icon-color);
}

.expand-icon > svg {
  display: inline-block;
  width: var(--ic-space-lg);
  height: var(--ic-space-lg);
}

:host(.ic-select-disabled) .expand-icon,
:host(.ic-select-disabled) .expand-icon > svg > path {
  color: var(--ic-select-disabled-expand-icon-color);
}

:host(.ic-select-searchable) .expand-icon {
  padding-left: 0;
  height: 2.25rem;
}

:host(.ic-select-searchable) .expand-icon > svg {
  height: 2.25rem;
  padding: 0 calc(var(--ic-space-xxxs) + var(--ic-space-xxs)) 0
    var(--ic-space-xxs);
}

:host(.ic-select-searchable:not(.ic-select-disabled)) .expand-icon > svg {
  cursor: pointer;
}

.expand-icon-open {
  color: var(--ic-select-expand-icon-color);
}

.expand-icon-open,
:host(.ic-select-searchable) .expand-icon-open {
  transform: rotateX(180deg);
}

.placeholder {
  color: var(--ic-select-content-placeholder-text);
}

:host(.ic-select-disabled) .value-text,
:host(.ic-select-disabled) .select-input,
:host(.ic-select-disabled) .placeholder,
:host(.ic-select-disabled.ic-select-searchable) .select-input::placeholder {
  color: var(--ic-select-content-text-disabled);
}

.select-input-end {
  display: flex;
  align-items: center;
}

.clear-button-container {
  display: flex;
  align-items: center;
}

.divider {
  width: var(--ic-space-1px);
  background-color: var(--ic-select-content-divider);
  margin: var(--ic-space-xxs) 0;
  border-radius: var(--ic-space-1px);
  height: var(--ic-space-lg);
}

:host(.ic-select-small) .divider {
  height: var(--ic-space-md);
}

:host(.ic-select-large) .divider {
  height: var(--ic-space-xl);
}

.clear-button {
  color: var(--ic-select-clear-button);
  position: absolute;
  right: calc(var(--ic-space-xl) + var(--ic-space-xxs) - var(--ic-space-1px));
  border-radius: var(--ic-border-radius);
  transition: box-shadow var(--ic-easing-transition),
    border-radius var(--ic-easing-transition);
}

.clear-button:focus,
.clear-button:active {
  background-color: var(--ic-color-focus-inner);
  box-shadow: inset 0 0 0 0.125rem var(--ic-color-focus-outer);
  border-radius: 0.25rem;
}

.clear-button:focus,
.clear-button:active * {
  fill: var(--ic-atoms-input-clear-button-focus);
}

.clear-button.searchable {
  position: static;
}

.aria-live-hidden-text {
  border: 0;
  clip: rect(0, 0, 0, 0, 0);
  height: var(--ic-space-1px);
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: var(--ic-space-1px);
}

::slotted([slot="icon"]) {
  fill: var(--ic-select-content-placeholder-text);
}

.has-value ::slotted([slot="icon"]) {
  fill: var(--ic-select-content-text);
}

.readonly ::slotted([slot="icon"]) {
  padding: 0.375rem;
  margin-bottom: 0.75rem;
}

@media (forced-colors: active) {
  .has-value ::slotted([slot="icon"]) {
    fill: currentcolor;
  }
}

@media (prefers-reduced-motion: reduce) {
  .clear-button,
  ic-input-validation.menu-open .status-icon,
  ic-input-validation.menu-open .statustext {
    transition: none;
  }
}
